import { type DateArg, format } from "date-fns";
import {
  enUS,
  es,
  faIR,
  fr,
  hi,
  ja,
  ko,
  ptBR,
  uk,
  zhCN,
} from "date-fns/locale";
import { match } from "ts-pattern";

import type { Locale } from "~/i18n";

export const formatDate = (
  date: DateArg<Date>,
  formatStr: string,
  locale: Locale,
) => {
  return format(date, formatStr, {
    locale: match(locale)
      .with("en-US", () => enUS)
      .with("es-ES", () => es)
      .with("fr-FR", () => fr)
      .with("hi-IN", () => hi)
      .with("ja-JP", () => ja)
      .with("ko-KR", () => ko)
      .with("zh-CN", () => zhCN)
      .with("fa-IR", () => faIR)
      .with("pt-BR", () => ptBR)
      .with("uk-UA", () => uk)
      .exhaustive(),
  });
};
